/* App settings */

var env = "{}";

var build_number = "localhost";

if (process && process.env) {
	if (process.env.REACT_APP_BUILD_NUMBER) {
		build_number = process.env.REACT_APP_BUILD_NUMBER;
	}
	if (process.env.REACT_APP_VMAE_BROADBAND) {
		env = process.env.REACT_APP_VMAE_BROADBAND;
	}
}

var Settings = JSON.parse(env);

if (process.env.REACT_APP_TRNSLT) {
	Settings.translations_container = process.env.REACT_APP_TRNSLT;
}

Settings.save_coverage_point = true;

Settings.newsletter_preference_id = 3;
Settings.router_locked_preference_id = 8;

Settings.home_internet_link = "/help/home-internet-everything-to-know/";
Settings.money_back_link = "https://www.virginmobile.ae/legal/consumer-services-agreement";
Settings.stores_link = "https://www.virginmobile.ae/stores/";

Settings.modem_info_link = "/help/home-internet-coverage-check/";
Settings.legal_link = "https://www.virginmobile.ae/legal";

Settings.buildNumber = build_number;
Settings.plans_prefix = "vmo_";
Settings.types = ["DATA", "BroadbandDevice"];
Settings.specs_list_order = ["DATA", "BroadbandDevice"];

Settings.plan_circles_order = ["DATA", "BroadbandDevice"];

Settings.types_human_map = {
	"VOICE-LCL": "local",
	DATA: "data",
	"VOICE-INT": "international",
	BroadbandDevice: "modem",
};

Settings.types_human_map_short = {
	"VOICE-LCL": "local",
	DATA: "data",
	"VOICE-INT": "int",
	BroadbandDevice: "BroadbandDevice",
};

Settings.types_human_caps = {
	"VOICE-LCL": "Local",
	DATA: "Data",
	"VOICE-INT": "International",
	BroadbandDevice: "BroadbandDevice",
};

Settings.mobile_horizontal_cards = true;

Settings.unlimited_value = -1;
Settings.unlimited_text = "Unlimited"; // TODO - Move this to translation strings
Settings.unlimited_text_short = "unl";
Settings.unlimited_sorting_gb_equiv = 10000;

Settings.types_new_order = ["DATA", "VOICE-LCL", "VOICE-INT"];

Settings.tooltips_order = [
	"data rollover",
	"local plan",
	"data plan",
	"international plan",
	"unlimited local",
];
Settings.enable_gtm_tracking = true
Settings.formats = {
	// email:/^\w(.\w*)+@[a-zA-Z_]+?\.[a-zA-Z]{2,5}$/,
	email: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	cardnumber: /^[0-9]{4}[ ]{0,1}[0-9]{4}[ ]{0,1}[0-9]{4}[ ]{0,1}[0-9]{4}|^3[47][0-9 ]{5,}$/,

	cards: {
		amex: /^(37|34)[0-9 ]{0,}$/,
		visa: /^4/,
		mastercard: /^5[1-5][0-9]{14,}$/,
		// mastercard: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)/
	},

	amex_mask: [
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		" ",
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		" ",
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		" ",
		/\d/,
		/\d/,
		/\d/,
	],
	card_mask: [
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		" ",
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		" ",
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		" ",
		/\d/,
		/\d/,
		/\d/,
		/\d/,
	],
	mask_emirates_id: [
		/\d/,
		/\d/,
		/\d/,
		"-",
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		"-",
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		"-",
		/\d/,
	],

	limits: {
		card_max: /^.{15}|.{16}$/,
		cvv_max: /^[0-9]{3}$/,
		card_date_max: /^.{5}$/,
		card_general_max: /^.{16}$/,
		card_amex_max: /^.{15}$/,
	},

	cardcvvInitial: /^([0-9]{0,3})$/,
	cardcvvInitialAmex: /^([0-9]{0,4})$/,

	cardcvv: /^([0-9]{3,4})$/,
	cardcvv4: /^([0-9]{4})$/,
	expiry: /^[0-9]{1,2}\/[0-9]{2}$/,

	digits_slashes: /^[0-9]{0,2}\/{0,1}[0-9]{0,2}$/,
	emirates_id: /^[0-9]{15}$/,

	phonemax: /^.{0,12}$/,

	max_10: /^.{0,10}$/,
	max_20: /^.{0,20}$/,

	phonenumber: /^[0-9]{6,12}$/,
	uaephonenumber: /^[0-9]{10,12}$/,
	phonefragment: /^[0-9]{1,7}$/,
	phonefragmentmax: /^[0-9]{0,7}$/,
	text_only: /^([^0-9]*)$/,
	card_text_only: /^[a-zA-Z ]*$/,
	digits_only: /^([0-9]*)$/,
	floats: /^([0-9].*)$/,
	rating_feedback: /^[^<>{}()_*^#]{0,50}$/,
	card_number_mask: [
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		" ",
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		" ",
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		" ",
		/\d/,
		/\d/,
		/\d/,
		/\d/,
	],
	minLength: /(.{8,})/,
	oneDigit: /(?=.*?[0-9])/,
	oneUpperCaseCharacter: /(?=.*[A-Z])/,
};

export default Settings;
